module.exports = __webpack_public_path__ + "img/56676b0.png";